import { CajaCurricularI } from "interfaces/CajaCurricular";
import { useEffect, useMemo, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { EspaciosTable, EspaciosTableRow } from "components/EspaciosTable/EspaciosTable";

interface Props {
  onClose?: () => void;
  elemento: CajaCurricularI | null;
  showModal: boolean;
}

export const CajaCurricularDetailModal = ({ elemento, showModal, onClose }: Props) => {
  const espaciosTableRows: EspaciosTableRow[] = useMemo(() => {
    if (!elemento?.espaciosCurriculares) return [];
    
    return elemento.espaciosCurriculares.map((esp: any) => ({
      id: esp.id,
      nombre: esp.nombre,
      anio: esp.anio ?? 0,
      horasSemanales: esp.horas_semanales,
      cuatrimestre: esp.cuatrimestre ?? null,
      area: esp.area?.nombre ?? esp.area_nombre ?? "",
      // La API devuelve tipoEspacio (camelCase); los espacios de la caja no pasan por makeEspacioCurricular
      tipoEspacio: esp.tipoEspacio?.nombre ?? esp.tipo_espacio?.nombre ?? "",
    }));
  }, [elemento]);

  return (
    <>
      <Modal show={showModal} onHide={onClose} size="xl" centered>
        <Modal.Header>
          <Modal.Title>{"Detalle Caja Curricular:"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Col>
            <Row>
              <Col sm={6} lg={4} className="mb-4">
                <b>Nombre:</b> <br></br>
                {elemento?.nombre}
              </Col>

              <Col sm={6} lg={4} className="mb-4">
                <b>Planes de estudio:</b> <br></br>
                {elemento?.planesEstudio && elemento.planesEstudio.length > 0 ? (
                  <ul className="mb-0" style={{ paddingLeft: "18px" }}>
                    {elemento.planesEstudio.map((plan) => (
                      <li key={plan.id}>{plan.nombre}</li>
                    ))}
                  </ul>
                ) : (
                  <span className="text-muted">Ninguno</span>
                )}
              </Col>

              <hr></hr>

              <Col sm={12} className="mb-4">
                <h5 className="mb-3">Espacios Curriculares:</h5>
                {espaciosTableRows.length > 0 ? (
                  <EspaciosTable 
                    espacios={espaciosTableRows} 
                    readonly 
                    maxHeight="400px"
                  />
                ) : (
                  <p className="text-muted">Sin espacios curriculares configurados.</p>
                )}
              </Col>
            </Row>
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="mx-3"
            variant="secondary"
            size="lg"
            onClick={onClose}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
